import { render, staticRenderFns } from "./comp-rab.vue?vue&type=template&id=04218bfb&"
import script from "./comp-rab.vue?vue&type=script&lang=js&"
export * from "./comp-rab.vue?vue&type=script&lang=js&"
import style0 from "./comp-rab.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports